module.exports = __webpack_public_path__ + "images/cebsblogo_white.1789097746312.png";